import { registerFeatureWithDescription } from "lib/features"

export const FEATURE_FLAG_SHARE_LINK_FIELDS = registerFeatureWithDescription({
    numericalId: 23,
    id: "share-link-fields",
    name: "Share-Link Requested Information",
    internalUseOnly: true,
    descriptionLines: [
        "Lets a share-link creator define a set of fields (text, number, currency, date, choice and rich text) that recipients are asked to complete.",
    ],
})
